var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{class:_vm.classes},[(Array.isArray(_vm.error))?_c('div',{staticClass:"form-error"},[_vm._v(_vm._s(_vm.error.join(',')))]):_vm._e(),_vm._v(" "),(_vm.error instanceof String)?_c('div',{staticClass:"form-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }